import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-user-roles-list',
  templateUrl: './user-roles-list.component.html'
})
export class UserRolesListComponent implements OnInit {
  @Input('roles') roles: any[] = [];
  @Input('user') user!: User;
  @Input('adminRightsCurrentUser') adminRightsCurrentUser: string[] = [];
  @Input('righsEditable') righsEditable: boolean = false;
  @Output('updateUserInRole') updateUserInRole: EventEmitter<any> = new EventEmitter();
  
  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }
  
  updateRoles(event: any) {
    if(event.value) {
      this.roles.push(event.key);
    } else {
      let roleIndex: number = this.roles.findIndex(s => s === event.key);
      this.roles.splice(roleIndex, 1);
    }
    this.updateUserInRole.emit(this.roles);
  }


}
